import { apiCall } from './generated/gqlClient';

const loginApiRequest = async (email, password, appName, appVersion, appOs) => {
  const query = `
    query login($email: String!, $password: String!, $appName: String, $appVersion: String, $appOs: String) {
      login(email: $email, password: $password, appName: $appName, appVersion: $appVersion, appOs: $appOs) {
        success
        accessToken
        expirationTimestamp
        refreshToken
        userId
        userRole
      }
    }
  `;
  return apiCall({ query, variables: { email, password, appName, appVersion, appOs } });
};

const refreshTokenApiRequest = async (refToken, providerId, appVersion, appName) => {
  const query = `
    query refreshToken($refToken: String!, $providerId: Int, $appVersion: String, $appName: String) {
      refreshToken(refToken: $refToken, providerId: $providerId, appVersion: $appVersion, appName: $appName) {
        success
        accessToken
        refreshToken
        userId
      }
    }
  `;
  return apiCall({ query, variables: { refToken, providerId, appVersion, appName } });
};

export { loginApiRequest, refreshTokenApiRequest };
